import React, { useState } from 'react';

import { PrimaryFilters as PrimaryFiltersProvider } from 'components/Filters';
import { ScreenFilters } from 'components/Filters';

import { Button, Grid, Typography } from '@gogame/components';
import { Filter } from '@gogame/filters';

import { useChildComponent } from '@gogame/hooks-ts';
import { createScreenRoute, Screen, withScreen } from '@gogame/screens';

import Palette from './components/palette';
import { EMPTY_FILTERS } from '../Affiliates/schemas';
import { useCancelationStorm, useLoadCancelationStorm } from './data';
import {
  useM500,
  useReq1,
  useReq2,
  useReq3,
  useReq4,
  useReq5,
  useInternalError,
  useEconnreset,
  useInternalError500Long,
} from './data/mutations';
import { playgroundLink } from './navigation';
import screenReducer from './screenReducer';
import { loadBigDataMultiselect } from './sources/playground';
import ErrorDetails from './ErrorDetails';

const permission = 20;
const id = -1;

const ErrorComponent = () => {
  let a = {};
  return <b>{a.b.c}</b>;
};
const Scene = withScreen({
  name: 'playground',
  reducer: screenReducer,
})(() => {
  const [childComponent, setChildComponent] = useChildComponent();
  const { data: stormData } = useLoadCancelationStorm();
  const [cancelationStorm1] = useCancelationStorm();
  const [cancelationStorm2] = useCancelationStorm();
  const [errorComponentVisible, setErrorComponentVisible] = useState(null);
  const [m500] = useM500();

  const [req1] = useReq1();
  const [req2] = useReq2();
  const [req3] = useReq3();
  const [req4] = useReq4();
  const [req5] = useReq5();
  const [reqInternalError500Long] = useInternalError500Long();

  const [internalError] = useInternalError();
  const [econnreset] = useEconnreset();

  const handleReq1 = () => {
    req1();
  };
  const handleReq2 = () => {
    req2();
  };
  const handleReq3 = () => {
    req3();
  };
  const handleReq4 = () => {
    req4();
  };
  const handleReq5 = () => {
    req5();
  };
  const handle500 = () => {
    m500();
  };
  const handleInternalError = () => {
    internalError();
  };
  const handleEconnreset = () => {
    econnreset();
  };
  const handleUIError1 = () => {
    let a = 1;
    a();
  };
  const handleUIError2 = () => {
    throw new Error('UI custom error text');
  };

  const handleCancelStorm = async () => {
    for (let i = 0; i < 10; i++) {
      await Promise.race([
        cancelationStorm1({ ...stormData }),
        new Promise((resolve) => {
          setTimeout(() => {
            cancelationStorm2({ ...stormData }).then(resolve);
          }, 50);
        }),
      ]);
    }
  };

  const handleInternalError500Long = () => {
    reqInternalError500Long();
  };

  const handleRenderError = () => {
    setErrorComponentVisible(true);
  };

  const handleOpenSidePage = () => {
    setChildComponent(ErrorDetails);
  };
  return (
    <React.Fragment>
      <Screen.Toolbar />
      <Screen.Body>
        <Grid container direction={'column'}>
          <Typography variant={'subtitle1'}>Errors handlers</Typography>
          <Grid spacing={2} container direction={'row'}>
            <Grid item>
              <Button variant={'outlined'} onClick={handleUIError1}>
                UI error undefined()
              </Button>
            </Grid>
            <Grid item>
              <Button variant={'outlined'} onClick={handleUIError2}>
                UI error a.undefined.c
              </Button>
            </Grid>
            <Grid item>
              <Button variant={'outlined'} onClick={handleCancelStorm}>
                API Cancelation Storm (cost-model)
              </Button>
            </Grid>
            <Grid item>
              <Button variant={'outlined'} onClick={handleReq1}>
                API Request 1 - 500 V1
              </Button>
            </Grid>
            <Grid item>
              <Button variant={'outlined'} onClick={handleReq2}>
                API Request 2 - 500 V2
              </Button>
            </Grid>
            <Grid item>
              <Button variant={'outlined'} onClick={handleReq3}>
                API Request 3 - 404 Nodejs
              </Button>
            </Grid>
            <Grid item>
              <Button variant={'outlined'} onClick={handleReq4}>
                API Request 4 - 404 DotNet
              </Button>
            </Grid>
            <Grid item>
              <Button variant={'outlined'} onClick={handleReq5}>
                API Request 5
              </Button>
            </Grid>
            <Grid item>
              <Button variant={'outlined'} onClick={handle500}>
                API ctx.throw 500
              </Button>
            </Grid>
            <Grid item>
              <Button variant={'outlined'} onClick={handleInternalError}>
                API NodeJS error
              </Button>
            </Grid>
            <Grid item>
              <Button variant={'outlined'} onClick={handleEconnreset}>
                API econnreset
              </Button>
            </Grid>
            <Grid item>
              <Button variant={'outlined'} onClick={handleInternalError500Long}>
                InternalError500Long
              </Button>
            </Grid>
            <Grid item>
              <Button variant={'outlined'} onClick={handleRenderError}>
                Error in render component
              </Button>
            </Grid>
            <Grid item>
              <Button variant={'outlined'} onClick={handleOpenSidePage}>
                Open Sidepage
              </Button>
            </Grid>

            <Grid item>
              <ScreenFilters emptyValues={EMPTY_FILTERS}>
                <PrimaryFiltersProvider primary={['channels']}>
                  <Filter.MultiSelect
                    title={'Channels'}
                    name={'channels'}
                    source={loadBigDataMultiselect}
                    withAll={false}
                    placeholder={'All'}
                  />
                </PrimaryFiltersProvider>
              </ScreenFilters>
            </Grid>

            {childComponent}
          </Grid>
        </Grid>

        <Grid container direction={'column'}>
          <Typography variant={'subtitle1'}>Palette</Typography>
          <Palette />
        </Grid>
        {errorComponentVisible ? <ErrorComponent /> : null}
      </Screen.Body>
    </React.Fragment>
  );
});
export default createScreenRoute({
  title: 'Playground',
  link: playgroundLink,
  screen: <Scene />,
  id: id,
  permission: permission,
  hidden: true,
});
